import React, { useEffect, useState, useRef } from "react";
import { Accordion, Modal, Form } from "react-bootstrap";
import { FaAngleUp } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import axios from 'axios';
import Spinner from 'react-bootstrap/Spinner';
import { SITE_URL } from "../../Api/config";
import { API_URL } from "../../Api/config";
import { apiCall, getCurrentUser } from "../../Api/auth";
import { getreferralforfront } from "../../Api/iron";
import ButtonList from "../ButtonList/ButtonList";
import { Tab, Nav } from 'react-bootstrap';

function RemoateFitting({ setuserlogin, showpopup, setpupfalse }) {

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [userdata, setUserdata] = React.useState(null);
    const [validated, setValidated] = useState(false);


    const [firstname, setFirstname] = useState('');
    const [lastname, setLastname] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [descripation, setDescripation] = useState('');
    const [city, setCity] = useState('');
    const [state, setState] = useState('');
    const [heightft, setHeightft] = useState(0);
    const [heightin, setHeightin] = useState(0);
    const [dexterity, setDexterity] = useState(0);
    const [appicall, setApicall] = useState(false);
    const [serverSideError, setServerSideError] = useState(null);
    const [userid, setUserid] = useState(null);
    const [refferalId, setRefferalId] = useState(null);
    const [referralName, setreferralName] = useState(null);


    const [password, setPassword] = useState('');
    const [zip, setZip] = useState('');
    const [address, setAddress] = useState('');

    const [golfers, setGolfers] = useState([]);

    const phoneNumRef = useRef(null);
    const emailRef = useRef(null);

    const addGolfer = () => {
        const newGolfer = { id: Date.now(), firstName: '', lastName: '', phone_number: '', email: '' };
        setGolfers([...golfers, newGolfer]);
    };

    const removeGolfer = (id) => {
        setGolfers(golfers.filter(golfer => golfer.id !== id));
    };

    const updateGolfer = (id, field, value) => {
        const updatedGolfers = golfers.map(golfer => {
            if (golfer.id === id) {
                return { ...golfer, [field]: value };
            }
            return golfer;
        });
        setGolfers(updatedGolfers);
    };

    const handleSubmit = (event) => {
        setApicall(true);
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
            setApicall(false);
        } else {
            event.preventDefault();

            axios.post(API_URL + 'remotefittinginquires/addremotefittinginquires', {
                firstName: firstname,
                lastName: lastname,
                phoneNumber: phone,
                email: email,
                description: descripation,
                city: city,
                state: state,
                address: address,
                zip: zip,
                password: password,
                subject: 'Remoate Fitting',
                fitting_type: "remotefitting_query",
                height_in: heightin,
                height_ft: heightft,
                dexterity: dexterity,
                // userarray: { id: Date.now(), firstName: 'not set', lastName: 'not set', phone_number: '123456789', email: 'notset@test.com' }
                userarray: golfers,
                userid: userid,
                refferalId: refferalId,
                referralName: referralName
            }
                , {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
                .then(response => {
                    if (response.data.status == true) {
                        handleShow02();
                        setDescripation('');
                        setHeightft('');
                        setHeightin('');
                        setDexterity('');
                        setValidated(false);
                        setServerSideError(null);
                        handleClose();
                        setGolfers([]);
                        if (userid === null) {
                            setFirstname('');
                            setLastname('');
                            setPhone('');
                            setEmail('');
                            setCity('');
                            setState('');
                            setZip('');
                            setHeightft('');
                            setDexterity('');
                            setHeightin('');
                        }
                        if (userid !== null) {
                            // localStorage.setItem("user", JSON.stringify(response.data.data));
                            setFirstname(response.data.data.firstname);
                            setLastname(response.data.data.lastname);
                            setPhone(response.data.data.phone);
                            setCity(response.data.data.city);
                            setState(response.data.data.state);
                            setZip(response.data.data.zip);
                            setHeightft(response.data.data.height_ft);
                            setHeightin(response.data.data.height_in);
                            setDexterity(response.data.data.dexterity);
                        }
                    } else {
                        setServerSideError(response.data.error);
                    }
                    // do something with response, like setting a success message state
                })
                .catch(error => {
                    console.log(error);
                    setServerSideError(error.response.data);
                    // handle the error
                }).finally(() => {
                    setApicall(false);
                });
        }

        setValidated(true);
    }

    useEffect(() => {
        if (serverSideError) {
            serverSideError.data.forEach(error => {
                if (error.field === "phone_number") {
                    phoneNumRef.current.focus();
                }
                if (error.field === "email") {
                    emailRef.current.focus();
                }
            });
        }
    }, [serverSideError]);

    const [show02, setShow02] = useState(false);

    const handleClose02 = () => setShow02(false);
    const handleShow02 = () => setShow02(true);

    useEffect(() => {
        // setUserdata(getCurrentUser());
        const fetchUserData = async () => {
            try {
                const userData = await getCurrentUser();
                if (userData) {
                    setUserdata(userData);
                    setFirstname(userData.user.firstname);
                    setLastname(userData.user.lastname);
                    setEmail(userData.user.email);
                    setPhone(userData.user.phone);
                    setAddress(userData.user.address);
                    setCity(userData.user.city);
                    setState(userData.user.state);
                    setZip(userData.user.zip);
                    setUserid(userData.user._id);
                    setHeightft(userData.user.height_ft);
                    setHeightin(userData.user.height_in);
                    setDexterity(userData.user.dexterity);
                } else {
                    // Handle case where user data is missing or incomplete
                    console.error('User data is missing or incomplete.');
                }
            } catch (error) {
                // Handle any errors that occur during data fetching
                console.error('Error fetching user data:', error);
            }
        };

        fetchUserData();
        getreferralfunc();
    }, []);

    const [errors, setErrors] = React.useState([]);
    const [refferals, setrefferals] = useState([]);

    const getreferralfunc = () => {
        setApicall(true);
        getreferralforfront().then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                setrefferals(data);
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            setApicall(false);
        });
    };

    const [startloader, setStartloader] = useState(false);

    const handlelogin = async (event) => {
        setStartloader(true);
        apiCall(API_URL + "user/login", "POST", { email: email, password: password }, event).then((res) => {
            if (!res.data.status) { setErrors(res.data.error); }
            else {
                console.log("res.data.data", res.data.data);
                localStorage.setItem("user", JSON.stringify(res.data.data));
                setuserlogin(res.data.data)
                setUserid(res.data.data.user._id)
                setServerSideError(null);
                // fetchUserData();
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            setStartloader(false);
        });
        setValidated(true);
    }

    useEffect(() => {
        // setUserdata(getCurrentUser());
        const fetchUserData = async () => {
            try {
                const userData = await getCurrentUser();
                if (userData) {
                    setUserdata(userData);
                } else {
                    // Handle case where user data is missing or incomplete
                    console.error('User data is missing or incomplete.');
                }
            } catch (error) {
                // Handle any errors that occur during data fetching
                console.error('Error fetching user data:', error);
            }
        };

        fetchUserData();
    }, []);

    useEffect(() => {
        if (showpopup !== 0) {
            handleShow();
        }
    }, [showpopup])

    const url = window.location.href.split('/')[3];

    return (
        <>

            <Modal
                show={show02}
                onHide={handleClose02}
                centered
                id="success_tic"
                className='model-thank-you'
            >
                <Modal.Body>
                    <div className="custom-modal-header">
                        <div className="logo-modal">
                            <img src={require('../../assets/images/logo_text.png')} alt="logo" />
                        </div>
                        <div className="close-modal">
                            <button type="button" className="btn-close" onClick={handleClose02} aria-label="Close"> <IoClose /></button>
                        </div>
                    </div>
                    <div className='modal-image'>
                        <img src={require('../../assets/images/forewardFormSubmitRemoteFitting.png')} alt="logo" />
                    </div>
                    <h3 className="text-center mb-4">
                        Your remote inquiry is sent!
                    </h3>
                    <p className="text-center mb-0">
                        Our staff will be in contact shortly to work out the details and get your fitting scheduled.
                    </p>
                </Modal.Body>
            </Modal>


            <Modal size="lg" centered show={show} onHide={handleClose} className="card-radius popup-modal-dark">
                <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile">
                    <div className="close-modal">
                        <div className="custom-modal-header">
                            <h3 className="text">Fitting Options</h3>
                            <button type="button" className="btn-close" onClick={handleClose} aria-label="Close">
                                <IoClose />
                            </button>
                        </div>
                    </div>

                    <div className="sec-tab mt-4">
                        <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                            <div className="row">
                                <div className="col-sm-12">
                                    <Nav variant="pills" className="flex-row user_desk_tab vhjgvjh">
                                        <Nav.Item>
                                            <Nav.Link eventKey="first">Remote Fitting</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="second">Studio Fitting</Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </div>
                                <div className="col-sm-12">
                                    <Tab.Content>
                                        <Tab.Pane eventKey="first">
                                            <div className="col-12 mt-4">
                                                <div className="ifream-video-box ratio ratio-16x9 iframe_wrapper">
                                                    <div id="v-video" className="v-video">
                                                        <iframe
                                                            // ref="playerRefs"
                                                            src="https://player.vimeo.com/video/898470013?h=b2407d1914&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;controls=1"
                                                            frameborder="0"
                                                            allow="autoplay; fullscreen; picture-in-picture"
                                                            allowfullscreen=""
                                                            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                                                            title="Video-1"
                                                            data-ready="true"
                                                        ></iframe>
                                                    </div>
                                                </div>
                                            </div>
                                            <Form noValidate validated={validated} onSubmit={handleSubmit}>
                                                <div className="row gx-2 mt-4">
                                                    <div className="col-md-6 form-group">
                                                        {/* <label htmlFor="firstName">First Name</label> */}
                                                        <input
                                                            type="text"
                                                            id="firstName"
                                                            name="given-name"
                                                            className="form-control dashboard-input-box-3"
                                                            value={firstname || ""}
                                                            onChange={(e) => setFirstname(e.target.value)}
                                                            placeholder="First name"
                                                            autoComplete="given-name"
                                                            required
                                                        />
                                                        <Form.Control.Feedback type="invalid">
                                                            Please enter a first name.
                                                        </Form.Control.Feedback>
                                                    </div>
                                                    <div className="col-md-6 form-group">
                                                        {/* <label htmlFor="lastName">Last Name</label> */}
                                                        <input
                                                            type="text"
                                                            id="lastName"
                                                            name="family-name"
                                                            className="form-control dashboard-input-box-3"
                                                            value={lastname || ""}
                                                            onChange={(e) => setLastname(e.target.value)}
                                                            placeholder="Last name"
                                                            autoComplete="family-name"
                                                            required
                                                        />
                                                        <Form.Control.Feedback type="invalid">
                                                            Please enter a last name.
                                                        </Form.Control.Feedback>
                                                    </div>

                                                    <div className="col-6 col-md-3 form-group" controlid="validationCustom011">
                                                        <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" value={heightft} required onChange={(e) => setHeightft(e.target.value)} aria-label="Default select example">
                                                            <option value={''}>ft.</option>
                                                            <option value="4">4 ft.</option>
                                                            <option value="5">5 ft.</option>
                                                            <option value="6">6 ft.</option>
                                                            <option value="7">7 ft.</option>
                                                        </select>
                                                        <Form.Control.Feedback type="invalid">
                                                            Please select a ft.
                                                        </Form.Control.Feedback>
                                                    </div>
                                                    <div className="col-6 col-md-3 form-group" controlid="validationCustom012">
                                                        <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" value={heightin} required onChange={(e) => setHeightin(e.target.value)} aria-label="Default select example">
                                                            <option value={''}>in.</option>
                                                            <option value="1">0 in.</option>
                                                            <option value="2">1 in.</option>
                                                            <option value="3">2 in.</option>
                                                            <option value="4">3 in.</option>
                                                            <option value="5">4 in.</option>
                                                            <option value="6">5 in.</option>
                                                            <option value="7">6 in.</option>
                                                            <option value="8">7 in.</option>
                                                            <option value="9">8 in.</option>
                                                            <option value="10">9 in.</option>
                                                            <option value="11">10 in.</option>
                                                            <option value="12">11 in.</option>
                                                        </select>
                                                        <Form.Control.Feedback type="invalid">
                                                            Please select a in.
                                                        </Form.Control.Feedback>
                                                    </div>
                                                    <div className="col-12 col-md-6 form-group" controlid="validationCustom013">
                                                        <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" value={dexterity} onChange={(e) => setDexterity(e.target.value)} aria-label="Default select example" required>
                                                            <option value={''}>Dexterity</option>
                                                            <option value="1">Right Handed</option>
                                                            <option value="2">Left Handed</option>
                                                        </select>
                                                        <Form.Control.Feedback type="invalid">
                                                            Please select a Dexterity
                                                        </Form.Control.Feedback>
                                                    </div>
                                                    <div className="col-md-12 form-group" controlid="validationCustom03">
                                                        <input type="tel" name="name" pattern="[0-9]{8,}" ref={phoneNumRef} value={phone || ""} title="Please enter a 8-digit phone number." onChange={(e) => setPhone(e.target.value)} className="form-control dashboard-input-box-3" placeholder="Phone" required />
                                                        <Form.Control.Feedback type="invalid">
                                                            Please enter a 8-digit phone number.
                                                        </Form.Control.Feedback>
                                                        {serverSideError && (serverSideError.data).map((error, index) => (
                                                            error.field === 'phone_number' ? (
                                                                <div className="text-danger" key={index}>{error.detail}</div>
                                                            ) : null
                                                        ))}
                                                    </div>
                                                    <div className="col-md-12 form-group" controlid="validationCustom04">
                                                        <input type="email" disabled={userid !== null} className="form-control dashboard-input-box-3" value={email || ""} ref={emailRef} name="email" onChange={(e) => setEmail(e.target.value)} placeholder="Email" required />
                                                        <Form.Control.Feedback type="invalid">
                                                            Please choose a email.
                                                        </Form.Control.Feedback>
                                                        {serverSideError && (serverSideError.data).map((error, index) => (
                                                            error.field === 'email' && error.userindex == 0 ? (
                                                                <div className="text-danger" key={index}>{error.message}</div>
                                                            ) : null
                                                        ))}
                                                    </div>
                                                    {serverSideError &&
                                                        serverSideError.data.map((error, index) => {
                                                            if (error.field === 'email' && error.userindex === 0 && error.user_role === 4 && error.detail === "Email already exists.") {
                                                                return (
                                                                    <React.Fragment key={index}>
                                                                        <div className="col-md-8 form-group" controlid="validationCustom04">
                                                                            <input
                                                                                type="password"
                                                                                disabled={userid !== null}
                                                                                className="form-control dashboard-input-box-3"
                                                                                value={password}
                                                                                name="email"
                                                                                onChange={(e) => setPassword(e.target.value)}
                                                                                placeholder="Enter your password"
                                                                                required
                                                                            />
                                                                            {errors && (errors).map((error, index) => (
                                                                                error.field === 'password' ? (
                                                                                    <div className="text-danger" key={index}>{error.message}</div>
                                                                                ) : null
                                                                            ))}
                                                                        </div>
                                                                        <div className="col-md-4 form-group" controlid="validationCustom04">
                                                                            <button className="btn btn_default bg-white text-dark btn_disabled" onClick={handlelogin}>
                                                                                {
                                                                                    startloader ? <Spinner animation="border" className="border-black" /> : <span>login </span>
                                                                                }
                                                                            </button>
                                                                        </div>
                                                                    </React.Fragment>
                                                                );
                                                            }
                                                            return null;
                                                        })}
                                                    <h3 className="text mt-3 mb-3">Shipping Information</h3>
                                                    <div className="description mb-4">
                                                        Let us know where exactly you want the Foreward remote fitting kit sent to.
                                                    </div>

                                                    <div className="col-md-12 form-group" controlid="validationCustom04">
                                                        <input type="text" className="form-control dashboard-input-box-3" value={address || ""} onChange={(e) => setAddress(e.target.value)} name="address" placeholder="Street Address, Apt. #" required />
                                                        <Form.Control.Feedback type="invalid">
                                                            Please choose a street address.
                                                        </Form.Control.Feedback>
                                                    </div>
                                                    <div className="col-4 col-md-6 form-group">
                                                        {/* <label htmlFor="city">City</label> */}
                                                        <input
                                                            type="text"
                                                            id="city"
                                                            name="address-level2"
                                                            className="form-control dashboard-input-box-3"
                                                            value={city || ""}
                                                            onChange={(e) => setCity(e.target.value)}
                                                            placeholder="City"
                                                            autoComplete="address-level2"
                                                            required
                                                        />
                                                        <Form.Control.Feedback type="invalid">
                                                            Please enter your city.
                                                        </Form.Control.Feedback>
                                                    </div>

                                                    <div className="col-4 col-md-3 form-group">
                                                        {/* <label htmlFor="state">State</label> */}
                                                        <input
                                                            type="text"
                                                            id="state"
                                                            name="address-level1"
                                                            className="form-control dashboard-input-box-3"
                                                            value={state || ""}
                                                            onChange={(e) => setState(e.target.value)}
                                                            placeholder="State"
                                                            autoComplete="address-level1"
                                                            required
                                                        />
                                                        <Form.Control.Feedback type="invalid">
                                                            Please enter your state.
                                                        </Form.Control.Feedback>
                                                    </div>

                                                    {/* Zip Code */}
                                                    <div className="col-4 col-md-3 form-group">
                                                        {/* <label htmlFor="zip">Zip Code</label> */}
                                                        <input
                                                            type="text"
                                                            id="zip"
                                                            name="postal-code"
                                                            className="form-control dashboard-input-box-3"
                                                            value={zip || ""}
                                                            onChange={(e) => setZip(e.target.value)}
                                                            placeholder="Zip Code"
                                                            autoComplete="postal-code"
                                                            required
                                                        />
                                                        <Form.Control.Feedback type="invalid">
                                                            Please enter your zip code.
                                                        </Form.Control.Feedback>
                                                    </div>
                                                </div>
                                                <div className='col-md-12 form-group' controlid="validationCustom05">
                                                    <textarea className="form-control dashboard-input-box-3 step-textarea-box" name="message" onChange={(e) => setDescripation(e.target.value)} placeholder="Any shipping notes?" rows="8"></textarea>
                                                    <Form.Control.Feedback type="invalid">
                                                        Please enter an description.
                                                    </Form.Control.Feedback>
                                                </div>


                                                <h3 className="text mt-3 mb-3">Were You Referred?</h3>
                                                <div className="description mb-4">
                                                    If you were referred let us know who it was so they can get credit. If not just select no referral.
                                                </div>
                                                <div className="col-12 form-group mb-5" controlid="validationCustom013">
                                                    {/* <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" value={dexterity} onChange={(e) => setDexterity(e.target.value)} aria-label="Default select example" required>
                                                        <option value={''}>Select Referral</option>
                                                        <option value="1">Referral 1</option>
                                                        <option value="2">Referral 2</option>
                                                        <option value="3">Referral 3</option>
                                                    </select> */}
                                                    <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" required value={refferalId} onChange={(e) => {
                                                        setRefferalId(e.target.value);
                                                        setreferralName(e.target.options[e.target.selectedIndex].text);
                                                    }} aria-label="Default select example" required style={{ textTransform: "capitalize" }} name="refferalId">
                                                        <option value="">Select referral</option>
                                                        <option value="1">No referral</option>
                                                        {
                                                            refferals && refferals.map((refferal, index) =>
                                                                <option key={index} value={refferal._id}>{refferal.fullname}</option>)
                                                        }
                                                    </select>

                                                    <Form.Control.Feedback type="invalid">
                                                        Please select a Referral
                                                    </Form.Control.Feedback>
                                                </div>

                                                <h3 className="text mt-3 mb-3">Add more golfers</h3>
                                                <div className="description mb-5">
                                                    Add as many as you want. The only thing we require is that all players are either right or left handed.
                                                </div>
                                                {golfers.map((golfer, index) => (
                                                    <div key={golfer.id} className="add-golfer-section mb-4">
                                                        <div className="add-golfer-header">
                                                            <div className="add-golfer-header-text">
                                                                Guest {index + 1}
                                                            </div>
                                                            <div className="remove-golfer-section">
                                                                <button type="button" className="btn-close" aria-label="Close" onClick={() => removeGolfer(golfer.id)}>
                                                                    <IoClose />
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div className="add-golfer-body">
                                                            <div className="row gx-2">
                                                                <div className="col-6 col-md-6 form-group" controlid="validationCustom01">
                                                                    <input type="text" name="f-name" value={golfer.firstName}
                                                                        onChange={(e) => updateGolfer(golfer.id, 'firstName', e.target.value)}
                                                                        className="form-control dashboard-input-box-3" placeholder="First name" required />
                                                                    <Form.Control.Feedback type="invalid">
                                                                        Please enter a first name.
                                                                    </Form.Control.Feedback>
                                                                </div>
                                                                <div className="col-6 col-md-6 form-group" controlid="validationCustom01">
                                                                    <input type="text" name="l-name" value={golfer.lastName}
                                                                        onChange={(e) => updateGolfer(golfer.id, 'lastName', e.target.value)} className="form-control dashboard-input-box-3" placeholder="Last name" required />
                                                                    <Form.Control.Feedback type="invalid">
                                                                        Please enter a first name.
                                                                    </Form.Control.Feedback>
                                                                </div>
                                                                <div className="col-6 col-md-3 form-group" controlid="validationCustom01">
                                                                    <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" value={golfer.ft} onChange={(e) => updateGolfer(golfer.id, 'heightft', e.target.value)} aria-label="Default select example" required>
                                                                        <option value={''}>ft.</option>
                                                                        <option value="4">4 ft.</option>
                                                                        <option value="5">5 ft.</option>
                                                                        <option value="6">6 ft.</option>
                                                                        <option value="7">7 ft.</option>
                                                                    </select>
                                                                    <Form.Control.Feedback type="invalid">
                                                                        Please select a ft.
                                                                    </Form.Control.Feedback>
                                                                </div>
                                                                <div className="col-6 col-md-3 form-group" controlid="validationCustom01">
                                                                    <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" onChange={(e) => updateGolfer(golfer.id, 'heightin', e.target.value)} aria-label="Default select example" required>
                                                                        <option value={''}>in.</option>
                                                                        <option value="1">0 in.</option>
                                                                        <option value="2">1 in.</option>
                                                                        <option value="3">2 in.</option>
                                                                        <option value="4">3 in.</option>
                                                                        <option value="5">4 in.</option>
                                                                        <option value="6">5 in.</option>
                                                                        <option value="7">6 in.</option>
                                                                        <option value="8">7 in.</option>
                                                                        <option value="9">8 in.</option>
                                                                        <option value="10">9 in.</option>
                                                                        <option value="11">10 in.</option>
                                                                        <option value="12">11 in.</option>
                                                                    </select>
                                                                    <Form.Control.Feedback type="invalid">
                                                                        Please select a in.
                                                                    </Form.Control.Feedback>
                                                                </div>
                                                                <div className="col-12 col-md-6 form-group" controlid="validationCustom01">
                                                                    <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" onChange={(e) => updateGolfer(golfer.id, 'dexterity', e.target.value)} aria-label="Default select example" required>
                                                                        <option value={''}>Dexterity</option>
                                                                        <option value="1">Right Handed</option>
                                                                        <option value="2">Left Handed</option>
                                                                    </select>
                                                                    <Form.Control.Feedback type="invalid">
                                                                        Please select a Dexterity
                                                                    </Form.Control.Feedback>
                                                                </div>
                                                                <div className="col-md-12 form-group" controlid="validationCustom03">
                                                                    <input type="tel" name="phone_number" pattern="[0-9]{8,}" value={golfer.phone_number}
                                                                        onChange={(e) => updateGolfer(golfer.id, 'phone_number', e.target.value)} title="Please enter a 8-digit phone number." className="form-control dashboard-input-box-3" placeholder="Phone" required />
                                                                    <Form.Control.Feedback type="invalid">
                                                                        Please enter a 8-digit phone number.
                                                                    </Form.Control.Feedback>
                                                                </div>
                                                                <div className="col-md-12 form-group" controlid="validationCustom04">
                                                                    <input type="email" className="form-control dashboard-input-box-3" value={golfer.email}
                                                                        onChange={(e) => updateGolfer(golfer.id, 'email', e.target.value)} name="email" placeholder="Email" required />
                                                                    <Form.Control.Feedback type="invalid">
                                                                        Please choose a email.
                                                                    </Form.Control.Feedback>
                                                                    {serverSideError && (serverSideError.data).map((error, errorindex) => (
                                                                        error.field == 'email' && error.userindex == index + 1 ? (
                                                                            <div className="text-danger" key={errorindex}>{error.detail}</div>
                                                                        ) : <></>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                                <div className="col-md-12 text-center">
                                                    <div className='full-width-btn'>
                                                        <button className="btn btn_default bg-white text-dark btn_disabled" onClick={addGolfer} type="button">
                                                            <span>+ Add Golfer</span>
                                                        </button>
                                                    </div>
                                                </div>
                                                <h3 className="text mt-4 mb-3">Get Your Remote Fitting Started</h3>
                                                <div className="description mb-5">
                                                    Once you fill out this form our team will be in touch within 24 hours to coordinate your remote club fitting.
                                                </div>
                                                <div className="col-md-12 text-center">
                                                    <div className='full-width-btn'>
                                                        <button className="btn btn_default bg-white text-dark btn_disabled" type="submit">
                                                            {
                                                                appicall ? <Spinner animation="border" className="border-black" /> : <span>Start Your Fitting </span>
                                                            }
                                                        </button>
                                                    </div>
                                                </div>
                                            </Form>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="second">
                                            <div className="row mt-4 mx-1 hide-phone">
                                                <div className="back-bg col-12 ">
                                                    <div className="row d-flex align-items-center justify-content-between ">
                                                        <div className="gvyvv d-flex flex-column col-6 px-4">
                                                            <div className="gab_title">
                                                                <div className="gab_icon">
                                                                    <img src={require('../../assets/images/forewardLandingClubs.png')} alt="" />
                                                                </div>
                                                                <div className="gab_text text-left">
                                                                    <h5>Complete Bag</h5>
                                                                    <small>Club Fitting </small>
                                                                </div>
                                                            </div>
                                                            <div className="gs_fr_text">
                                                                <p>
                                                                    Four sessions to get your bag fit and built to your specs.
                                                                </p>
                                                                <a className="link-icon" href="#"> Four 1.5 hour fitting sessions</a>
                                                            </div>
                                                            <button onClick={() => window.open("https://squareup.com/appointments/book/04e7x17cqe2t5b/LPA9B43QT768F/start", "_blank")} className="btn btn_default bg-white text-dark gs_fr_action efwfewf">
                                                                Book now for <strong>$499</strong>
                                                            </button>
                                                        </div>
                                                        <div className="col-1" style={{ backgroundColor: '#1e2025' }}></div>
                                                        <div className="vvhiuhiuhf d-flex flex-column align-items-center justify-content-center col-5 py-5">
                                                            <div id="outer" className="vbbvuygu">
                                                                <ul id="tick" className="gs_fr_list pb-0 list-unstyled">
                                                                    <li className=""><i className="bi bi-check me-2"></i> Save 25%</li>
                                                                    <li className=""><i className="bi bi-check me-2"></i> Driver + Woods</li>
                                                                    <li className=""><i className="bi bi-check me-2"></i> Irons + Hybrids</li>
                                                                    <li className=""><i className="bi bi-check me-2"></i> Wedges</li>
                                                                    <li className=""><i className="bi bi-check me-2"></i> Putter</li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="mt-4">
                                                    <div className="row d-flex align-items-center gap-4 mini-rate">
                                                        <div className="col-6 back-bg">
                                                            <div className="gab_title">
                                                                <div className="gab_icon">
                                                                    <img src={require('../../assets/images/DriverClubSelections.png')} alt="" />
                                                                </div>
                                                                <div className="gab_text">
                                                                    <h5>Driver + Woods</h5>
                                                                    <small>Club Fitting </small>
                                                                </div>
                                                            </div>
                                                            <div className="gs_fr_text">
                                                                <p>
                                                                    Get your driver and woods fit and built to your specs.
                                                                </p>
                                                                <a className="link-icon" href="#"> One 1.5 hour fitting session</a>
                                                            </div>
                                                            <button onClick={() => window.open("https://squareup.com/appointments/buyer/widget/qv2fqmjlvm78yr/LPA9B43QT768F", "_blank")} className="btn btn_default bg-white text-dark gs_fr_action efwfewf rfgreg">
                                                                Book now for <strong>$199</strong>
                                                            </button>
                                                        </div>
                                                        <div className="col-6 back-bg">
                                                            <div className="gab_title">
                                                                <div className="gab_icon">
                                                                    <img src={require('../../assets/images/7IronClubSelections.png')} alt="" />
                                                                </div>
                                                                <div className="gab_text">
                                                                    <h5>Irons + Hybrids</h5>
                                                                    <small>Club Fitting </small>
                                                                </div>
                                                            </div>
                                                            <div className="gs_fr_text">
                                                                <p>
                                                                    Get your irons and hybrids fit and built to your specs.
                                                                </p>
                                                                <a className="link-icon" href="#"> One 1.5 hour fitting session</a>
                                                            </div>
                                                            <button onClick={() => window.open("https://squareup.com/appointments/buyer/widget/j57hiynj5uucjx/LPA9B43QT768F", "_blank")} className="btn btn_default bg-white text-dark gs_fr_action efwfewf rfgreg">
                                                                Book now for <strong>$199</strong>
                                                            </button>
                                                        </div>
                                                        <div className="col-6 back-bg">
                                                            <div className="gab_title">
                                                                <div className="gab_icon">
                                                                    <img src={require('../../assets/images/GabWedgeClubSelections.png')} alt="" />
                                                                </div>
                                                                <div className="gab_text">
                                                                    <h5>Wedges</h5>
                                                                    <small>Club Fitting </small>
                                                                </div>
                                                            </div>
                                                            <div className="gs_fr_text">
                                                                <p>
                                                                    Get the wedges in your bag fit and built to your specs.
                                                                </p>
                                                                <a className="link-icon" href="#"> One 1.5 hour fitting session</a>
                                                            </div>
                                                            <button onClick={() => window.open("https://squareup.com/appointments/buyer/widget/irjd9e8xh35etq/LPA9B43QT768F", "_blank")} className="btn btn_default bg-white text-dark gs_fr_action efwfewf rfgreg">
                                                                Book now for <strong>$199</strong>
                                                            </button>
                                                        </div>
                                                        <div className="col-6 back-bg">
                                                            <div className="gab_title">
                                                                <div className="gab_icon">
                                                                    <img src={require('../../assets/images/Putter.png')} alt="" />
                                                                </div>
                                                                <div className="gab_text">
                                                                    <h5>Putter</h5>
                                                                    <small>Club Fitting </small>
                                                                </div>
                                                            </div>
                                                            <div className="gs_fr_text">
                                                                <p>
                                                                    Get your putter analyzed, fit and built to your specs.
                                                                </p>
                                                                <a className="link-icon" href="#"> One 1.5 hour fitting session</a>
                                                            </div>
                                                            <button onClick={() => window.open("https://squareup.com/appointments/buyer/widget/s1d6wiohzhipid/LPA9B43QT768F", "_blank")} className="btn btn_default bg-white text-dark gs_fr_action efwfewf rfgreg">
                                                                Book now for <strong>$199</strong>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row mt-4 mx-1 show-mobile">
                                                <Accordion>
                                                    <div className="row">
                                                        <div className="col-12 back-bg-acc p-0">
                                                            <Accordion.Item eventKey="0" className="mobile-accordion">
                                                                <div className="gs_b gs_fr rate_card_mobile accordion-item">
                                                                    <div className="gs_fr_top" id="lesson_card_1">
                                                                        <Accordion.Header>
                                                                            <div className="gab_title">
                                                                                <div className="gab_text text-left">
                                                                                    <h5>Complete Bag</h5>
                                                                                    <small>Club Fitting </small>
                                                                                </div>
                                                                                <div className="collapsed">
                                                                                    <div className="gab_icon ">
                                                                                        <FaAngleUp />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </Accordion.Header>
                                                                    </div>
                                                                    <Accordion.Body>
                                                                        <div className="gs_fr_text">
                                                                            <p>
                                                                                Four sessions to get your bag fit and built to your specs.
                                                                            </p>
                                                                            <a className="link-icon" href="#"> Four 1.5 hour fitting session</a>
                                                                        </div>
                                                                        <ul className="gs_fr_list">
                                                                            <li className><i className="bi bi-check" /> Save 25%</li>
                                                                            <li className><i className="bi bi-check" /> Driver + Woods</li>
                                                                            <li className><i className="bi bi-check" /> Irons + Hybrids</li>
                                                                            <li className><i className="bi bi-check" /> Wedges</li>
                                                                            <li className><i className="bi bi-check" /> Putter</li>
                                                                        </ul>
                                                                        {/* <a className="" onClick={handleShow}>Complete Bag3 <strong>$499</strong></a> */}

                                                                        <a href="https://squareup.com/appointments/book/04e7x17cqe2t5b/LPA9B43QT768F/start" target="_blank" className="btn btn_default bg-white text-dark gs_fr_action">
                                                                            Book now for <strong>$499</strong>
                                                                        </a>


                                                                    </Accordion.Body>
                                                                </div>
                                                            </Accordion.Item>
                                                        </div>
                                                        <div className="col-12 back-bg-acc p-0">
                                                            <Accordion.Item eventKey="1" className="mobile-accordion">
                                                                <div className="gs_b gs_fr rate_card_mobile accordion-item">
                                                                    <div className="gs_fr_top" id="lesson_card_1">
                                                                        <Accordion.Header>
                                                                            <div className="gab_title">
                                                                                <div className="gab_text">
                                                                                    <h5>Driver + Woods</h5>
                                                                                    <small>Club Fitting </small>
                                                                                </div>
                                                                                <div className="collapsed">
                                                                                    <div className="gab_icon ">
                                                                                        <FaAngleUp />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </Accordion.Header>
                                                                    </div>
                                                                    <Accordion.Body>
                                                                        <div className="gs_fr_text">
                                                                            <p>
                                                                                Get your driver and woods fit and built to your specs.
                                                                            </p>
                                                                            <a className="link-icon" href="#"> One 1.5 hour fitting session</a>
                                                                        </div>
                                                                        <a href="https://squareup.com/appointments/buyer/widget/qv2fqmjlvm78yr/LPA9B43QT768F" target="_blank" className="btn btn_default bg-white text-dark gs_fr_action">Book now for <strong>$199</strong></a>
                                                                    </Accordion.Body>
                                                                </div>
                                                            </Accordion.Item>
                                                        </div>
                                                        <div className="col-12 back-bg-acc p-0">
                                                            <Accordion.Item eventKey="2" className="mobile-accordion">
                                                                <div className="gs_b gs_fr rate_card_mobile accordion-item">
                                                                    <div className="gs_fr_top" id="lesson_card_1">
                                                                        <Accordion.Header>
                                                                            <div className="gab_title">
                                                                                <div className="gab_text">
                                                                                    <h5>Irons + Hybrids</h5>
                                                                                    <small>Club Fitting </small>
                                                                                </div>
                                                                                <div className="collapsed">
                                                                                    <div className="gab_icon ">
                                                                                        <FaAngleUp />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </Accordion.Header>
                                                                    </div>
                                                                    <Accordion.Body>
                                                                        <div className="gs_fr_text">
                                                                            <p>
                                                                                Get your irons and hybrids fit and built to your specs.
                                                                            </p>
                                                                            <a className="link-icon" href="#"> One 1.5 hour fitting session</a>
                                                                        </div>
                                                                        <a href="https://squareup.com/appointments/buyer/widget/j57hiynj5uucjx/LPA9B43QT768F" target="_blank" className="btn btn_default bg-white text-dark gs_fr_action">Book now for <strong>$199</strong></a>
                                                                    </Accordion.Body>
                                                                </div>
                                                            </Accordion.Item>
                                                        </div>
                                                        <div className="col-12 back-bg-acc p-0">
                                                            <Accordion.Item eventKey="3" className="mobile-accordion">
                                                                <div className="gs_b gs_fr rate_card_mobile accordion-item">
                                                                    <div className="gs_fr_top" id="lesson_card_1">
                                                                        <Accordion.Header>
                                                                            <div className="gab_title">
                                                                                <div className="gab_text">
                                                                                    <h5>Wedges</h5>
                                                                                    <small>Club Fitting </small>
                                                                                </div>
                                                                                <div className="collapsed">
                                                                                    <div className="gab_icon ">
                                                                                        <FaAngleUp />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </Accordion.Header>
                                                                    </div>
                                                                    <Accordion.Body>
                                                                        <div className="gs_fr_text">
                                                                            <p>
                                                                                Get the wedges in your bag fit and built to your specs.
                                                                            </p>
                                                                            <a className="link-icon" href="#"> One 1.5 hour fitting session</a>
                                                                        </div>
                                                                        <a href="https://squareup.com/appointments/buyer/widget/irjd9e8xh35etq/LPA9B43QT768F" target="_blank" className="btn btn_default bg-white text-dark gs_fr_action">Book now for <strong>$199</strong></a>
                                                                    </Accordion.Body>
                                                                </div>
                                                            </Accordion.Item>
                                                        </div>
                                                        <div className="col-12 back-bg-acc p-0">
                                                            <Accordion.Item eventKey="4" className="mobile-accordion">
                                                                <div className="gs_b gs_fr rate_card_mobile accordion-item">
                                                                    <div className="gs_fr_top" id="lesson_card_1">
                                                                        <Accordion.Header>
                                                                            <div className="gab_title">
                                                                                <div className="gab_text">
                                                                                    <h5>Putter</h5>
                                                                                    <small>Club Fitting </small>
                                                                                </div>
                                                                                <div className="collapsed">
                                                                                    <div className="gab_icon ">
                                                                                        <FaAngleUp />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </Accordion.Header>
                                                                    </div>
                                                                    <Accordion.Body>
                                                                        <div className="gs_fr_text">
                                                                            <p>
                                                                                Get your putter analyzed, fit and built to your specs.
                                                                            </p>
                                                                            <a className="link-icon" href="#"> One 1.5 hour fitting session</a>
                                                                        </div>
                                                                        <a href="https://squareup.com/appointments/buyer/widget/s1d6wiohzhipid/LPA9B43QT768F" target="_blank" className="btn btn_default bg-white text-dark gs_fr_action">Book now for <strong>$199</strong></a>
                                                                    </Accordion.Body>
                                                                </div>
                                                            </Accordion.Item>
                                                        </div>
                                                    </div>
                                                </Accordion>
                                            </div>
                                        </Tab.Pane>
                                    </Tab.Content>
                                </div>
                            </div>
                        </Tab.Container>
                    </div>

                    {/* <div className="remoate-fitting-preview">
                        <img src={require('../../assets/images/thumb_img.jpg')} alt="logo" />
                    </div> */}
                    {/* <h3 className="text mb-4">Primary Golfer</h3>
                    <div className="description mb-4">
                        This should be the golfer that is ordering the remote fitting case and recieving the shipping information
                    </div> */}

                </Modal.Body>
            </Modal >


            {
                url !== "golf-clubs" && url !== "about-us" && url !== "fitter" &&
                <>
                    <section id="fitting_rate" className="fitting_rate bg_dark page-section pb-0">
                        <div className="container-xl separate-container">
                            <div className="d-flex align-items-center justify-content-between sec_tile_bar">
                                <h2 className="sec_title">We send it to you</h2>
                                <div className="btn-section hide_mobile">
                                    <ButtonList subject="club fitting" />
                                </div>
                            </div>
                            <div className="gs_b bg_green_dark page-section-bg hide_mobile_full">
                                <div className="row hide_mobile_f">
                                    <div className="col-lg-4 col-md-6 w_5872 color_green_bg">
                                        <div className="gs_fr_top">
                                            <div className="gab_title">
                                                <div className="gab_icon bg-black">
                                                    <img src={require('../../assets/images/map_(2).png')} alt="" style={{ width: "20px" }} />
                                                </div>
                                                <div className="gab_text text-left">
                                                    <h5>Remote Fitting</h5>
                                                    <small>Iron Fitting</small>
                                                </div>
                                            </div>
                                            <div className="gs_fr_text">
                                                <p>
                                                    We send you our fitting case <br /> and you send us the results.
                                                </p>
                                                {/* <a className="link-icon" href="#">Get fit on your own time</a> */}
                                                <a className="link-icon" href="#">$299 for unlimited golfers</a>
                                                {/* <a className="link-icon" href="#"> <i className="bi bi-youtube" /> Watch Video</a> */}
                                            </div>
                                            {/* {
                                        userdata === null ?
                                            (
                                                <a style={{ display: "none" }} onClick={handleShow} className="btn btn_default bg-white text-dark gs_fr_action hide_1280 hide_tab complate_bag_btn">
                                                    To get started <strong>Start Here</strong>
                                                </a>
                                            ) : userdata.user.role_id === 4 ? (
                                                <a href={`${SITE_URL}user-dashboard`} className="btn btn_default bg-white text-dark gs_fr_action hide_1280 hide_tab complate_bag_btn">
                                                    Go to <strong>Dashboard</strong>
                                                </a>
                                            ) : (
                                                <a style={{ display: "none" }} href={SITE_URL + `dashboard`} className="btn btn_default bg-white text-dark gs_fr_action hide_1280 hide_tab complate_bag_btn">
                                                    Go to  <strong>Dashboard</strong>
                                                </a>
                                            )
                                    } */}

                                            <a style={{ display: "none" }} onClick={handleShow} className="btn btn_default bg-white text-dark gs_fr_action hide_1280 hide_tab complate_bag_btn">
                                                To get started <strong>Click Here</strong>
                                            </a>
                                        </div>
                                        <div id="outer" className="marquee-5872 view-992">
                                            <ul id="tick" className="gs_fr_list">
                                                <li className><i className="bi bi-check" /> Shipping Included</li>
                                                <li className><i className="bi bi-check" /> Step By Step Directions</li>
                                                <li className><i className="bi bi-check" /> Get The Full Process</li>
                                            </ul>
                                        </div>
                                        {/* {
                                    userdata === null ?
                                        (
                                            <a onClick={handleShow} className="btn btn_default bg-white gs_fr_action hide_1280 hide_tab">
                                                To get started <strong>Start Here</strong>
                                            </a>
                                        ) : userdata.user.role_id === 4 ? (
                                            <a href={`${SITE_URL}user-dashboard`} className="btn btn_default bg-white gs_fr_action hide_1280 hide_tab">
                                                Go to <strong>Dashboard</strong>
                                            </a>
                                        ) : (
                                            <a href={SITE_URL + `dashboard`} className="btn btn_default bg-white gs_fr_action hide_1280 hide_tab">
                                                Go to <strong>Dashboard</strong>
                                            </a>
                                        )
                                } */}
                                        <a onClick={handleShow} className="btn btn_default bg-white gs_fr_action hide_1280 hide_tab">
                                            To get started <strong>Start Here</strong>
                                        </a>


                                    </div>
                                    <div className="col-lg-8 col-md-6">
                                        <div className="ifream-video-box ratio ratio-16x9 iframe_wrapper hide_mobile">
                                            <div id="v-video" className="v-video">
                                                <iframe
                                                    // ref="playerRefs"
                                                    src="https://player.vimeo.com/video/898470013?h=b2407d1914&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;controls=1"
                                                    frameborder="0"
                                                    allow="autoplay; fullscreen; picture-in-picture"
                                                    allowfullscreen=""
                                                    style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                                                    title="Video-1"
                                                    data-ready="true"
                                                ></iframe>
                                            </div>
                                        </div>
                                        <div id="outer" className="marquee-5872 view-992-only">
                                            <ul id="tick" className="gs_fr_list">
                                                <li className><i className="bi bi-check" /> Shipping Included</li>
                                                <li className><i className="bi bi-check" /> Step By Step Directions</li>
                                                <li className><i className="bi bi-check" /> Get The Full Process</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="marquee-wrapper slider-5872 bg_green_marquee">
                                    <div className>
                                        <div className="marquee-block marquee-block11">
                                            <div className="marquee-inner to-left">
                                                <span>
                                                    <div className="marquee-item">
                                                        <p className="gs_fr_list"><i className="bi bi-check" />Shipping Included</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" />Step By Step Directions</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" />Get The Full Process</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="gs_fr_list"><i className="bi bi-check" />Shipping Included</p>
                                                    </div>
                                                </span>
                                                <span>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" />Step By Step Directions</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" />Get The Full Process</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="gs_fr_list"><i className="bi bi-check" />Shipping Included</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" />Step By Step Directions</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" />Get The Full Process</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="gs_fr_list"><i className="bi bi-check" />Shipping Included</p>
                                                    </div>
                                                    <div className="marquee-item">
                                                        <p className="text-white"><i className="bi bi-check" />Step By Step Directions</p>
                                                    </div>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Accordion defaultActiveKey="0">
                                <div className="row show_mobile">
                                    <div className="col-lg-4">
                                        <Accordion.Item eventKey="0" className="mobile-accordion">
                                            <div className="gs_b gs_fr rate_card_mobile accordion-item bg_green_dark color_green_bg">
                                                <div className="gs_fr_top" id="lesson_card_1">
                                                    <Accordion.Header>
                                                        <div className="gab_title">
                                                            <div className="gab_text text-left">
                                                                <h5>Remote Fitting</h5>
                                                                <small>Iron Fitting</small>
                                                            </div>
                                                            <div className="collapsed">
                                                                <div className="gab_icon ">
                                                                    <FaAngleUp />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Accordion.Header>
                                                </div>
                                                <Accordion.Body className="">
                                                    <div className="ifream-video-box ratio ratio-16x9 iframe_wrapper mb-5">
                                                        <div id="v-video" className="v-video">
                                                            <iframe
                                                                // ref="playerRefs"
                                                                src="https://player.vimeo.com/video/898470013?h=b2407d1914&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;controls=1"
                                                                frameborder="0"
                                                                allow="autoplay; fullscreen; picture-in-picture"
                                                                allowfullscreen=""
                                                                style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                                                                title="Video-1"
                                                                data-ready="true"
                                                            ></iframe>
                                                        </div>
                                                    </div>
                                                    <div className="gs_fr_text">
                                                        <p>
                                                            We send you our fitting case <br /> and you send us the results.
                                                        </p>
                                                        {/* <a className="link-icon" href="#">Get fit on your own time</a> */}
                                                        <a className="link-icon" href="#">$299 for unlimited golfers</a>
                                                    </div>
                                                    <ul className="gs_fr_list">
                                                        <li className><i className="bi bi-check" /> Shipping Included</li>
                                                        <li className><i className="bi bi-check" /> Step By Step Directions</li>
                                                        <li className><i className="bi bi-check" /> Get The Full Process</li>
                                                    </ul>
                                                    {/* <a className="" onClick={handleShow}>Complete Bag3 <strong>$499</strong></a> */}


                                                    {/* {
                                                userdata === null ? (
                                                    <a onClick={handleShow} className="btn btn_default bg-white text-dark gs_fr_action"> 
                                                        To get started <strong>Start Here</strong>
                                                    </a>
                                                ) : userdata.user.role_id === 4 ? (
                                                    <a href={`${SITE_URL}user-dashboard`} className="btn btn_default bg-white text-dark gs_fr_action"> 
                                                        Go to <strong>Dashboard</strong>
                                                    </a>
                                                ) : (
                                                    <a href={`${SITE_URL}dashboard`} className="btn btn_default bg-white text-dark gs_fr_action"> 
                                                        To get started <strong>Dashboard</strong>
                                                    </a>
                                                )

                                            } */}

                                                    <a onClick={handleShow} className="btn btn_default bg-white text-dark gs_fr_action btnsizefix">
                                                        To get started <strong>Start Here</strong>
                                                    </a>


                                                </Accordion.Body>
                                            </div>
                                        </Accordion.Item>
                                    </div>
                                </div>
                            </Accordion>
                            <div className="btn-section hide_desktop-v2">
                                <ButtonList subject="club fitting" />
                            </div>
                        </div>
                    </section>
                </>
            }

            <style>
                {`
                .user_desk_tab.vhjgvjh .nav-item {
                    width: 50% !important;
                }
                .user_desk_tab.vhjgvjh .nav-item .nav-link {
                    background-color: transparent;
                    color: #ffffff;
                    border-radius: 20px;
                    font-size: 18px;
                    font-weight: 800;
                    height: 65px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .user_desk_tab.vhjgvjh .nav-item .nav-link.active {
                    background-color: #99ea24;
                    color: #262a31;
                }
                .user_desk_tab.vhjgvjh {
                    // background:rgba(46, 47, 50, 1);
                    background: #272a30;
                    border-radius: 20px;
                }

                .back-bg-acc .gs_b{
                    background-color: #272a30 !important;
                }
                .back-bg {
                    background: #272a30;
                    padding: 50px;
                    border-radius: 30px;
                }
                .back-bg .vvhiuhiuhf{
                    border-left: 3px solid rgb(31, 31, 36);
                }
                .back-bg .efwfewf{
                    min-width: 260px !important;
                    padding: 20px 15px !important;
                }

                .back-bg ul.gs_fr_list li {
                    font-size: 18px;
                    line-height: 1.8;
                    padding: 9px 0px;
                }

                .mini-rate .gab_text h5 {
                    font-size: 23px;
                }

                .back-bg .vvhiuhiuhf .vbbvuygu , ul.gs_fr_list {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    transition: all 0.5s ease-in-out;
                }

                @media only screen and (min-width: 1280px) and (max-width: 1439px) {
                    .gs_fr_action.btn_default {
                        margin: 0;
                    }
                }
                @media only screen and (min-width: 992px) and (max-width: 1279px) {
                    .gs_fr_text p {
                        font-size: 18px;
                    }
                    a.link-icon {
                        font-size: 18px;
                    }
                }
                @media only screen and (min-width: 710px) and (max-width: 776px) {
                    .back-bg .efwfewf.rfgreg {
                        min-width: 100% !important;
                    }
                }
                @media only screen and (min-width: 576px) and (max-width: 992px) {
                    .modal.show .modal-dialog{
                        min-width: 85vw !important;
                    }
                    .back-bg .efwfewf{
                        min-width: 100% !important;
                        padding: 20px 15px !important;
                    }
                }
                @media only screen and (min-width: 576px) and (max-width: 920px) {
                    .back-bg{
                        padding: 30px !important;
                    }
                }
                @media only screen and (min-width: 576px) and (max-width: 830px) {
                    
                    .gab_text h5 {
                        font-size: 20px !important;
                    }
                    .mini-rate .gab_text h5 {
                        font-size: 18px !important;
                    }
                    .gs_fr_text p {
                        font-size: 15px;
                        text-align: left !important;
                    }
                    a.link-icon {
                        font-size: 15px;
                        justify-content: flex-start !important;
                    }
                    .gs_fr_text {
                        padding: 35px 0;
                    }
                    .mini-rate .col-6{
                        width: 47% !important;
                    }
                }
                .hide-phone{
                    display: flex !important;
                }

                .show-mobile{
                    display: none !important;
                }

                .mini-rate .col-6{
                    width: 48% ;
                }
                @media only screen and (max-width: 710px) {
                    .hide-phone{
                        display: none !important;
                    }
                        .show-mobile{
                            display: flex !important;
                        }
                }
            }
            `}
            </style>
        </>
    );
}

export default RemoateFitting;